import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const SubscriberDetailHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);

  const doClose = () => setOpen(false);

  useEffect(() => {
    return actions.recv("open-help-dashboard", function () {
      setOpen(true);
    });
  }, []);
  return open !== true ? null : (
    <Modal
      title="Subscriber Group Dashboard"
      onClose={doClose}
      content={() => (
        <>
         <p>
            Shows current information and statistics for the selected
            subscriber group.
            <ul>
              <li>Click on the refresh <i className="material-icons valign-icon">refresh</i> icon to refresh the data. </li>
            </ul>
          </p>
          <br />
          <h5>Historical Metrics</h5>
          <p>
            This page shows the evolution over the selected period of time of a
            number of metrics:
            <ul>
              <li>
                The average speed (measured over 10-minute intervals) in the
                downlink and uplink directions.
              </li>
              <li>
                The number of active flows and the number of flows created in 10
                minute intervals.
              </li>
              <li>
              Latency Over Time:<br />
                RTT (Round-trip time) latency over time, measured with TCP acknowledgements, from the time data packets leave this node towards the end user until the acknowledgements are received by this node. It does not include the latency from this node to the servers in Internet.<br />
                If "P80-80th percentile" is selected, each measurement is the 80-th percentile of all downlink RTT latency samples in 10 minutes.<br />
                If "P50-Median" is selected, each measurement is the 50-th percentile (the median) of all downlink RTT latency samples in 10 minutes.<br />
                If "Mean-Min" is selected, each measurement is mean of all downlink RTT minimum latency samples, measured in 1-second intervals, during active downloads, in 10 minutes. The metric for all the network is also shown as a reference.
              </li>
              <li>
                The average packet retransmissions on the access side. As a
                reference, the average retransmissions for all the network
                subscribers groups are included.
              </li>
              <li>
                The average percent of downlink traffic that is detected as
                congested by the ACM functionality.
              </li>
            </ul>
            This page also shows scatter-plots of selected mterics
            against the average group speed:
            <ul>
              <li>
                Latency vs Average Speed: scatter plot of latency-speed pairs.
              </li>
              <li>
                Packet Retransmissions vs Average Speed: scatter plot of
                retransmissions-speed pairs.
              </li>
              <li>
                Congestion vs Average Speed: scatter plot of congestion-speed
                pairs.
              </li>
            </ul>
          </p>
          <br />
          <h5>Live Throughput </h5>
          <ul>
            <li>
              Click on the {" "}<i className="material-icons valign-icon">insert_chart</i> Live Throughput button to see the subscribers throughput in live mode.
            </li>
            </ul>
          <br />
          <h5>Subscriber group editing </h5>
          <ul>
            <li>
              Click on the {" "}<i className="material-icons valign-icon">edit</i> Edit subscriber group members button to edit
              the subscriber group.
            </li>
            <li>
              Click on the {" "}<i className="material-icons valign-icon">multiline_chart</i> See main subscribers in group
              button to see the active subscribers.
            </li>
            <li>
              Click on the {" "}<i className="material-icons valign-icon">edit</i> icon next to Rate-Policy to select a rate policy for this subscriber group.
            </li>
            <li>
              If a rate policy is already assigned, click on its name to see its details, or to modify it if it is configurable.
            </li>
          </ul>
        </>
      )}
    />
  );
};
export default SubscriberDetailHelpModal;
